import React, { Component } from 'react';

class Home extends Component {
    componentDidMount(){
        console.log(process.env.NODE_ENV);
        console.log(process.env.REACT_APP_API_URL);
    }

    render() {
        return (
            <div>
                HOME!
                TODO lista!
            </div>

        );
    }
}
export default Home;
